import Cookies from 'js-cookie';

function setOptOutCookies(PgrOptOutPrefKey: string) {
    const PgrOptOutCookie = `C0004:${PgrOptOutPrefKey}`;
    // @ts-ignore: can't find config
    Cookies.set('PgrOptOutPref', PgrOptOutCookie, { domain: config.optOutDomain, path: '/', secure: false });
}

export default setOptOutCookies
